module.exports = __webpack_public_path__ + "static/media/tk-min.b3d28da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/tk-min.svg
// module id = 695
// module chunks = 0